export const FILE_SOURCE_NONE = 'NONE';
export const FLAGSMITH_TTL = 1000 * 90;

export const showPricesRetailerSide = 'show-prices-retailer-side';
export const tempHideHasPricePricingFilterSupplierIds = 'temp-hide-pricing-has-price-supplier-ids';
export const tiktokToggleConnectionStatus = 'tiktok_toggle_connection_status_dev_11404';
export const inventoryHistoryLogInitiatorFlag = 'inventory_history_log_initiator';
export const aiChatbot = 'ai-chatbot-dev-10945';

export const enableVariantBufferByUser = 'variant_buffer_by_user_dev_11853';
export const enableVariantBufferBySupplier = 'variant_buffer_by_supplier_dev_11853';

export const permittedUserRolesToEditInventoryQuantitiesViaPopup =
  'permitted_user_roles_to_edit_inventory_quantities_via_popup_dev-13170';

export const editVariantBufferByFileUpload = 'edit_variant_buffers_by_file_upload_dev-11777';

export const checkMiraklConfigurations = 'ui_check_missing_mirakl_configurations_dev_13836';
export const checkTikTokConfigurations = 'ui_check_missing_tiktok_configurations_dev_13836';

export const addDiscountAmountToOrdersReportAndApp = 'add_discount_amount_to_orders_report_and_app_dev_14230';

export const showRlrTableInSupplierOrder = 'ui_show_rlr_table_in_supplier_order_dev_14173';

export const supplierOrderReportWithCurrency = 'supplier_order_report_with_currency';
